import { Component, OnDestroy, OnInit } from '@angular/core';

import { ShipmentService } from '../shipment.service';
import { map, Subject, takeUntil } from 'rxjs';

@Component({
   selector: 'shipment-description',
   templateUrl: './description.component.html',
   styleUrls: ['./description.component.scss']
})
export class DescriptionComponent implements OnInit, OnDestroy {

   config;

   _onDestroy: Subject<void> = new Subject();

   public codForm;
   public descForm;
   public instForm;
   isQuote: any;

   constructor( public shipment: ShipmentService ) { }

   ngOnInit() {
      this.config = {
         description: this.shipment?.configs?.description,
         specialinstructions: this.shipment?.configs?.specialinstructions,
      };

      this.shipment.shipmentUpdate$.pipe(
         map(() => this.shipment.shipmentForm),
         takeUntil( this._onDestroy ),
      ).subscribe( shipmentForm => {
         this.isQuote = shipmentForm.get('isQuote');
         this.codForm = shipmentForm.get('cod');
         this.descForm = shipmentForm.get('description');
         this.instForm = shipmentForm.get('specialinstructions');

         if ( this.isQuote.value ) {
            shipmentForm.removeControl('description');
            shipmentForm.updateValueAndValidity();
         }

      });
   }

   ngOnDestroy() {
      this._onDestroy.next();
   }
}
